import { Icon } from '@design/components/icon/Icon';
import { InputHTMLAttributes } from 'react';

import styles from './SearchInput.module.scss';

export const SearchInput = ({
  placeholder,
  onClick,
}: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.inputContainer}>
        <div className={styles.searchIcon}>
          <Icon iconName="Search" size={20} />
        </div>

        <input
          className={styles.input}
          data-testid="header-search-input"
          readOnly
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
